import { useContext } from "react";
import { AlferdChatContext } from "../providers/alferd-chat-provider";

const UseChat = () => {
  const chat = useContext(AlferdChatContext);

  return chat;
};

export default UseChat;
